"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadThread = loadThread;
exports.docPathInThread = docPathInThread;
exports.saveThread = saveThread;
const path = __importStar(require("path"));
const fs = __importStar(require("fs-extra"));
const frontmatterLoader_1 = require("../serializers/frontmatterLoader");
const frontmatterSaver_1 = require("../serializers/frontmatterSaver");
const validation_1 = require("../../../core/dist/validation");
async function loadMdFiles(dir, typeName) {
    if (!await fs.pathExists(dir))
        return [];
    const files = (await fs.readdir(dir)).filter(f => f.endsWith('.md'));
    const results = [];
    for (const f of files) {
        try {
            const doc = await (0, frontmatterLoader_1.loadDoc)(path.join(dir, f));
            if (!typeName || doc.type === typeName)
                results.push(doc);
        }
        catch (e) {
            if (e instanceof frontmatterLoader_1.FrontmatterParseError) {
                console.warn(`[loadThread] Skipping ${f}: ${e.message}`);
            }
            else
                throw e;
        }
    }
    return results;
}
async function loadThread(loomRoot, weaveId, threadId, index, overrideThreadPath) {
    const threadPath = overrideThreadPath ?? path.join(loomRoot, 'loom', weaveId, threadId);
    let idea;
    const ideaPath = path.join(threadPath, `${threadId}-idea.md`);
    if (await fs.pathExists(ideaPath)) {
        idea = await (0, frontmatterLoader_1.loadDoc)(ideaPath);
    }
    let design;
    const designPath = path.join(threadPath, `${threadId}-design.md`);
    if (await fs.pathExists(designPath)) {
        design = await (0, frontmatterLoader_1.loadDoc)(designPath);
    }
    // req.md — the thread's authoritative include/exclude/constraints spec.
    // Flat filename (no `${threadId}-` prefix), like ctx.md.
    let req;
    const reqPath = path.join(threadPath, 'req.md');
    if (await fs.pathExists(reqPath)) {
        req = await (0, frontmatterLoader_1.loadDoc)(reqPath);
    }
    // thread.md — the thread manifest (authored th_ ULID + priority + depends_on).
    // Flat filename (no `${threadId}-` prefix), like ctx.md and req.md.
    let manifest;
    const manifestPath = path.join(threadPath, 'thread.md');
    if (await fs.pathExists(manifestPath)) {
        manifest = await (0, frontmatterLoader_1.loadDoc)(manifestPath);
    }
    const plans = await loadMdFiles(path.join(threadPath, 'plans'), 'plan');
    const dones = await loadMdFiles(path.join(threadPath, 'done'), 'done');
    const chats = await loadMdFiles(path.join(threadPath, 'chats'), 'chat');
    const refDocs = await loadMdFiles(path.join(threadPath, 'refs'));
    // Constraint warnings
    const rootFiles = await fs.readdir(threadPath).catch(() => []);
    if (rootFiles.filter(f => f.endsWith('-idea.md')).length > 1) {
        console.warn(`⚠️  [${weaveId}/${threadId}] Multiple idea docs — only one expected.`);
    }
    if (rootFiles.filter(f => f.endsWith('-design.md')).length > 1) {
        console.warn(`⚠️  [${weaveId}/${threadId}] Multiple design docs — only one expected.`);
    }
    const allDocs = [
        ...(idea ? [idea] : []),
        ...(design ? [design] : []),
        ...(req ? [req] : []),
        ...(manifest ? [manifest] : []),
        ...plans,
        ...dones,
        ...chats,
        ...refDocs,
    ];
    if (index) {
        for (const doc of allDocs) {
            if (doc.parent_id && !(0, validation_1.validateParentExists)(doc, index)) {
                console.warn(`⚠️  [${doc.id}] Broken parent_id: ${doc.parent_id}`);
            }
            const dangling = (0, validation_1.getDanglingChildIds)(doc, index);
            for (const childId of dangling) {
                console.warn(`⚠️  [${doc.id}] Dangling child_id: ${childId}`);
            }
        }
    }
    return { id: threadId, weaveId, idea, design, req, manifest, plans, dones, chats, refDocs, allDocs };
}
function docPathInThread(doc, threadPath, threadId) {
    switch (doc.type) {
        case 'idea': return path.join(threadPath, `${threadId}-idea.md`);
        case 'design': return path.join(threadPath, `${threadId}-design.md`);
        case 'req': return path.join(threadPath, 'req.md');
        case 'thread': return path.join(threadPath, 'thread.md');
        case 'plan': return path.join(threadPath, 'plans', `${doc.id}.md`);
        case 'done': return path.join(threadPath, 'done', `${doc.id}.md`);
        case 'chat': return path.join(threadPath, 'chats', `${doc.id}.md`);
        case 'reference': return path.join(threadPath, 'refs', `${doc.slug ?? doc.id}.md`);
        default: throw new Error(`Unknown doc type for thread: ${doc.type}`);
    }
}
async function saveThread(loomRoot, weaveId, thread) {
    const threadPath = path.join(loomRoot, 'loom', weaveId, thread.id);
    for (const doc of thread.allDocs) {
        const filePath = doc._path ?? docPathInThread(doc, threadPath, thread.id);
        await (0, frontmatterSaver_1.saveDoc)(doc, filePath);
    }
}
